import styled from 'styled-components';

import { devices } from '@/UI/Styles';

export const Wrapper = styled.div`
  margin: auto;
  padding: 0;
  position: relative;
  width: 100%;
  padding: 12px;

  @media ${devices['no-mobile']} {
    max-width: 540px;
    padding: 0;
  }
  @media ${devices.Medium} {
    max-width: 720px;
    padding: 0;
  }
  @media ${devices.Large} {
    max-width: 960px;
    padding: 0;
  }
  @media ${devices.XLarge} {
    max-width: 1140px;
    padding: 0;
  }
`;
